import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-ai-c mg-t-30" }
const _hoisted_2 = { class: "flex dialog-footer flex-jc-c" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    "before-close": _ctx.handleClose
  }, {
    title: _withCtx(() => _cache[4] || (_cache[4] = [
      _createElementVNode("div", { class: "fs-20 bold" }, [
        _createTextVNode(" 个人额度设置"),
        _createElementVNode("span", { class: "fs-14 fc-grey mg-l-25 normal" }, "设置个人预支额度后，申请额度将根据个人额度限制判断（其他额度限制不生效）")
      ], -1)
    ])),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" 提交 ")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "box" }, [
        _createElementVNode("div", { class: "flex head" }, [
          _createElementVNode("div", { class: "flex-1 border bold" }, "姓名"),
          _createElementVNode("div", { class: "flex-2 border bold" }, "身份证号"),
          _createElementVNode("div", { class: "flex-2 border bold" }, "手机号")
        ]),
        _createElementVNode("div", { class: "flex body" }, [
          _createElementVNode("div", { class: "flex-1 border" }, "李立明"),
          _createElementVNode("div", { class: "flex-2 border" }, "2342342334343242"),
          _createElementVNode("div", { class: "flex-2 border" }, "1233333333")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bold" }, [
          _createElementVNode("span", { class: "fc-red" }, "*"),
          _createTextVNode("单词申请额度上限：")
        ], -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_el_input_number, {
            modelValue: _ctx.num,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.num) = $event)),
            step: 2,
            placeholder: "请输入金额"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}